import { IApplicationState } from '../../types/redux';

export const selectListingsUrls = (state: IApplicationState) => {
  return state.listingsUrls;
};
